// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__iurbt"};